var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPortPoeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.8511L12.3333 11L8.6875 18.1489H14L5.33333 27L8.66667 19.8511H4Z",
    fill: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.2979L21.5 2L18.2188 8.70213H23L15.2 17L18.2 10.2979H14Z",
    fill: "#373737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.8511L26.3333 11L22.6875 18.1489H28L19.3333 27L22.6667 19.8511H18Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPortPoeDark);
export default __webpack_public_path__ + "static/media/icn_port_poe+++_Dark.0c970644e57dae82a7ada35425e7d61d.svg";
export { ForwardRef as ReactComponent };